// Pure, dependency-free format helpers for the import button. Kept separate
// from ImportDocxButton.tsx so they can be unit-tested without dragging in the
// heavy mammoth / @platejs/markdown parsers.

const DOCX_MIME = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
const DOC_MIME = 'application/msword';

// `accept` for the hidden <input type="file">. Some browsers report an empty
// MIME for these, so the real gate is the EXTENSION (classifyImportFile); the
// MIME types here just help the native picker pre-filter.
export const IMPORT_ACCEPT = `.md,.markdown,.docx,.doc,text/markdown,${DOCX_MIME},${DOC_MIME}`;

export type ImportKind = 'md' | 'docx' | 'doc' | 'html' | null;

/** Map a file name → how it should be parsed, or null when unsupported. */
export function classifyImportFile(fileName: string): ImportKind {
    const n = fileName.toLowerCase();
    if (n.endsWith('.md') || n.endsWith('.markdown')) return 'md';
    if (n.endsWith('.docx')) return 'docx'; // check before '.doc' so .docx wins
    if (n.endsWith('.doc')) return 'doc';
    if (n.endsWith('.html') || n.endsWith('.htm')) return 'html';
    return null;
}
